import { create } from 'zustand'

type DragState = {
  isDragging: boolean
  dx: number
  dy: number
}

type ArrowKeys = { left: boolean; right: boolean; up: boolean; down: boolean }

type InputState = {
  drag: DragState
  spin: { vx: number; vy: number }
  arrowKeys: ArrowKeys
  resetCubeRequested: number
  releaseCubeRequested: number

  setDragging: (v: boolean) => void
  addDrag: (dx: number, dy: number) => void
  setSpin: (vx: number, vy: number) => void
  decaySpin: (factor: number) => void
  setArrowKey: (key: keyof ArrowKeys, pressed: boolean) => void
  requestResetCube: () => void
  requestReleaseCube: () => void
}

export const useInputStore = create<InputState>((set) => ({
  drag: { isDragging: false, dx: 0, dy: 0 },
  spin: { vx: 0, vy: 0 },
  arrowKeys: { left: false, right: false, up: false, down: false },
  resetCubeRequested: 0,
  releaseCubeRequested: 0,

  setDragging: (v) =>
    set((s) => ({
      drag: { isDragging: v, dx: v ? 0 : s.drag.dx, dy: v ? 0 : s.drag.dy },
    })),
  addDrag: (dx, dy) =>
    set((s) => ({
      drag: { isDragging: s.drag.isDragging, dx: s.drag.dx + dx, dy: s.drag.dy + dy },
    })),
  setSpin: (vx, vy) => set({ spin: { vx, vy } }),
  decaySpin: (factor) => set((s) => ({ spin: { vx: s.spin.vx * factor, vy: s.spin.vy * factor } })),
  setArrowKey: (key, pressed) =>
    set((s) => ({ arrowKeys: { ...s.arrowKeys, [key]: pressed } })),
  requestResetCube: () => set((s) => ({ resetCubeRequested: s.resetCubeRequested + 1 })),
  requestReleaseCube: () => set((s) => ({ releaseCubeRequested: s.releaseCubeRequested + 1 })),
}))
